import { render, staticRenderFns } from "./CacheSystem.vue?vue&type=template&id=b9fb364e&scoped=true&"
import script from "./CacheSystem.vue?vue&type=script&lang=js&"
export * from "./CacheSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fb364e",
  null
  
)

export default component.exports